module.exports = __webpack_public_path__ + "img/damageReportLogoIcon.069d51bc.png";